import React, {} from 'react'
import { IconButton } from '@mui/material'
import { SaveSharp } from '@mui/icons-material'

export const SKUSaveButton = ({ handleUpdateClick, rows, selection, throwError}) => {

    let selectedRows = rows.filter((row, idx) => selection.includes(idx))

    return (
        <div>
            <IconButton
                aria-label="Save"
                onClick={(event) => {
                    if (selection.length === 0) {
                        throwError(event, `Please, select at least one row to update.`)
                    } else {
                        handleUpdateClick(selectedRows, "PUT")                        
                    }
                }}
                size="large"
            >
                <SaveSharp />
            </IconButton>
        </div>
    )
}